module.exports = __webpack_public_path__ + "static/media/Sofia-Pro-Regular.711f78e8.ttf";